import { DATA_LOADING_STATES, METRIC_NAMES } from '@config/Consts';

const metrics = {
  [METRIC_NAMES.CLOSED_CONVERSATIONS]: null,
  // [METRIC_NAMES.RESPONSE_TIME]: null, // Remove response time
  [METRIC_NAMES.LOAD_CONVERSATIONS]: null,
  [METRIC_NAMES.ASSIGNED_CONVERSATIONS]: null,
  [METRIC_NAMES.CSAT]: null,
  [METRIC_NAMES.OVERDUE_ASSIGNED]: null,
  [METRIC_NAMES.OVERDUE_IN_QUEUE]: null,
  [METRIC_NAMES.SKILL_UNASSIGNED_CONVERSATIONS]: null,
  [METRIC_NAMES.AVG_WAIT_TIME]: null,
  [METRIC_NAMES.AVG_WAIT_TIME_FIRST_RESPONSE]: null,
  [METRIC_NAMES.AVG_TIME_TO_RESPONSE]: null,
  [METRIC_NAMES.AVG_TIME_TO_FIRST_RESPONSE_FIRST_ASSIGNMENT]: null,
  [METRIC_NAMES.HUMAN_ONLINE_LOAD]: null,
  [METRIC_NAMES.HUMAN_AWAY_LOAD]: null,
  [METRIC_NAMES.CLOSED_BY_AGENT]: null,
  [METRIC_NAMES.CLOSED_BY_CONSUMER]: null,
  [METRIC_NAMES.AUTO_CLOSED]: null,
  [METRIC_NAMES.AVG_CONVERSATIONS_DURATION]: null,
};

const lastTimeDataUpdated = {
  [METRIC_NAMES.CLOSED_CONVERSATIONS]: null,
  [METRIC_NAMES.LOAD_CONVERSATIONS]: null,
  [METRIC_NAMES.ASSIGNED_CONVERSATIONS]: null,
  [METRIC_NAMES.CSAT]: null,
  [METRIC_NAMES.OVERDUE_ASSIGNED]: null,
  [METRIC_NAMES.OVERDUE_IN_QUEUE]: null,
  [METRIC_NAMES.SKILL_UNASSIGNED_CONVERSATIONS]: null,
  [METRIC_NAMES.AVG_WAIT_TIME]: null,
  [METRIC_NAMES.AVG_WAIT_TIME_FIRST_RESPONSE]: null,
  [METRIC_NAMES.AVG_TIME_TO_RESPONSE]: null,
  [METRIC_NAMES.AVG_TIME_TO_FIRST_RESPONSE_FIRST_ASSIGNMENT]: null,
  [METRIC_NAMES.HUMAN_ONLINE_LOAD]: null,
  [METRIC_NAMES.HUMAN_AWAY_LOAD]: null,
  [METRIC_NAMES.CLOSED_BY_AGENT]: null,
  [METRIC_NAMES.CLOSED_BY_CONSUMER]: null,
  [METRIC_NAMES.AUTO_CLOSED]: null,
  [METRIC_NAMES.AVG_CONVERSATIONS_DURATION]: null,
};

const metricsDataLoading = {
  [METRIC_NAMES.CLOSED_CONVERSATIONS]: DATA_LOADING_STATES.NONE,
  // [METRIC_NAMES.RESPONSE_TIME]: DATA_LOADING_STATES.NONE, // Remove response time
  [METRIC_NAMES.LOAD_CONVERSATIONS]: DATA_LOADING_STATES.NONE,
  [METRIC_NAMES.ASSIGNED_CONVERSATIONS]: DATA_LOADING_STATES.NONE,
  [METRIC_NAMES.CSAT]: DATA_LOADING_STATES.NONE,
  [METRIC_NAMES.OVERDUE_ASSIGNED]: DATA_LOADING_STATES.NONE,
  [METRIC_NAMES.OVERDUE_IN_QUEUE]: DATA_LOADING_STATES.NONE,
  [METRIC_NAMES.SKILL_UNASSIGNED_CONVERSATIONS]: DATA_LOADING_STATES.NONE,
  [METRIC_NAMES.AVG_WAIT_TIME]: DATA_LOADING_STATES.NONE,
  [METRIC_NAMES.AVG_WAIT_TIME_FIRST_RESPONSE]: DATA_LOADING_STATES.NONE,
  [METRIC_NAMES.AVG_TIME_TO_RESPONSE]: DATA_LOADING_STATES.NONE,
  [METRIC_NAMES.AVG_TIME_TO_FIRST_RESPONSE_FIRST_ASSIGNMENT]: DATA_LOADING_STATES.NONE,
  [METRIC_NAMES.HUMAN_ONLINE_LOAD]: DATA_LOADING_STATES.NONE,
  [METRIC_NAMES.HUMAN_AWAY_LOAD]: DATA_LOADING_STATES.NONE,
  [METRIC_NAMES.CLOSED_BY_AGENT]: DATA_LOADING_STATES.NONE,
  [METRIC_NAMES.CLOSED_BY_CONSUMER]: DATA_LOADING_STATES.NONE,
  [METRIC_NAMES.AUTO_CLOSED]: DATA_LOADING_STATES.NONE,
  [METRIC_NAMES.AVG_CONVERSATIONS_DURATION]: DATA_LOADING_STATES.NONE,
};

const firstTimeLoading = true;

export default {
  metricsDataLoading,
  firstTimeLoading,
  metrics,
  lastTimeDataUpdated,
};
